// Pantalla_Principal.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import '../styles/styles.css';
import '../styles/formularios.css';
import logoInstituto from '../components/images/logo.png';



const PantallaPrincipal = () => {
  const location = useLocation();

  useEffect(() => {
    // Aquí puedes reinicializar estados, volver a cargar datos, etc.
    console.log("PantallaPrincipal volvió a activarse");
  }, [location.key]); // location.key cambia aunque no cambie pathname


  return (
    <div className="pantalla-inicio container text-center mt-5">
      {/* Logo centrado arriba */}
      <div className="mb-3">
        <img
          src= {logoInstituto} 
          alt="Logo Instituto Silviano Carrillo"
          className="logo"
          style={{ width: "100px", display: "block", margin: "0 auto" }}
        />
      </div>

      <div
        className="card mx-auto p-5 shadow-lg"
        style={{
          maxWidth: "850px",
          borderRadius: "20px",
          backgroundColor: "#ffffffe6"
        }}
      >
        <h1 className="fw-bold text-dark">
          Instituto <span className="text-primary">"Silviano Carrillo"</span>
        </h1>
        <p className="text-muted fs-5 mb-4">Sección Primaria</p>

        <div className="seccion mb-4">
          <h2 className="titulo-seccion">MISIÓN</h2>
          <p className="texto-seccion">
            Anunciar el reino de Dios y colaborar con los Padres de Familia en la formación integral de los Alumnos, a la luz del Evangelio,
            teniendo como centro a Jesús Sacramentado, a fin de lograr auténticos hijos de Dios y ciudadanos de la Patria (II Crón. SJS).
          </p>
        </div>

        <div className="seccion mb-4">
          <h2 className="titulo-seccion">VISIÓN</h2>
          <p className="texto-seccion">
            El Instituto “Silviano Carrillo” es escuela innovadora a la vanguardia en procesos educativos de calidad,
            forma personas competentes capaces de enfrentar con éxito los retos del mundo actual, con dimensión trascendente.
          </p>
        </div>

        <div className="seccion">
          <h2 className="titulo-seccion">VALORES</h2>
          <p className="texto-seccion">
            Afirmamos el deber de vivir y proyectar los valores de la:<br />
            <strong className="d-block mt-2 text-uppercase">
              Unidad, Caridad, Alegría, Respeto, Responsabilidad, Solidaridad, Patriotismo y Gratitud.
            </strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PantallaPrincipal;

